import { useMemo } from 'react';

import { getFacebookLocale } from '@change-corgi/config/facebook';
import { useI18n } from '@change-corgi/core/react/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePetitionCommentPageData } from 'src/app/pages/petitionComment/pageContext';

type Result = ModelHookResult<{
	pageTitle: string;
	title: string;
	description: string;
	fbLocale: string;
	photo?: {
		url: string;
		width: number;
		height: number;
	};
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();
	const {
		data: {
			comment: { user, comment },
			petition: { ask, originalLocale, photo },
		},
	} = usePetitionCommentPageData();
	const { resolveUrl } = useUtilityContext();

	return {
		data: {
			pageTitle: translate('fe.pages.comment.page_title', { name: user.displayName }),
			title: `${user.firstName}: ${comment}`.substring(0, 400),
			description: ask,
			fbLocale: getFacebookLocale(originalLocale.localeCode) || getFacebookLocale('en-US'),
			photo: useMemo(() => {
				if (!photo) return undefined;

				return {
					url: resolveUrl(photo.petitionLarge.url),
					width: photo.petitionLarge.width,
					height: photo.petitionLarge.height,
				};
			}, [photo, resolveUrl]),
		},
	};
}
